import { PerplexityOnboardingResponse } from "0.Mine/3.Interfaces/PerplexityResponses";

import { AdditionalParams, QlickupActions, useQlickupAPI } from "../APICall";

import { extractJsonFromString } from "./Gemini";

export const usePerplexityAI = () => {
  const { QlickUpAPI } = useQlickupAPI();

  const fetchBusinessInformationFromWebsite = async (website: string) => {
    const prompt = `Visit the website ${website} and retrieve the following info, ensuring you place them in a json and return nothing but the json:
                        {
                        businessName:
                        businessDescription:
                        email:
                        address:
                        postalCode:
                        city:
                        country:
                        province:
                        Services: (array of strings)
                        }`;

    const params: AdditionalParams = {
      prompt: prompt,
    };

    try {
      const response = await QlickUpAPI(
        "0",
        "complete",
        null,
        "perplexity",
        QlickupActions.POST,
        params
      );

      console.log(response);

      if (response.success) {
        const jsonObject = extractJsonFromString(response.response);
        console.log("JSON OBJECT IS ", jsonObject);
        return jsonObject as PerplexityOnboardingResponse;
      } else {
        return null;
      }
    } catch (error) {
      console.error("Error fetching business information:", error);
      return null;
    }
  };

  return { fetchBusinessInformationFromWebsite };
};
